var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBulgaria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999C32 14.0428 31.648 12.168 31.0048 10.4347L16 9.73901L0.995188 10.4346C0.352063 12.168 0 14.0428 0 15.9999C0 17.957 0.352063 19.8318 0.995188 21.5651L16 22.2608L31.0048 21.5651C31.648 19.8318 32 17.957 32 15.9999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C22.8794 32 28.7441 27.658 31.0048 21.5652H0.995186C3.25587 27.658 9.12056 32 16 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995186 10.4348H31.0049C28.7441 4.342 22.8794 0 16 0C9.12056 0 3.25587 4.342 0.995186 10.4348Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBulgaria);
export default __webpack_public_path__ + "static/media/flag_bulgaria.324573563705f12baf669e0c54167dfd.svg";
export { ForwardRef as ReactComponent };